module.exports = __webpack_public_path__ + "media/images/category/dummy/outer03-6dac122192d388989f8a90eb358c662f.jpg";